import { render, staticRenderFns } from "./chkRegisterResult.vue?vue&type=template&id=7508246e&"
import script from "./chkRegisterResult.vue?vue&type=script&lang=js&"
export * from "./chkRegisterResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports